import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationSpatialScatterplotIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M649.333 62.8921L932.731 133.742C948.757 137.748 960 152.147 960 168.667V924C960 936.477 953.54 948.064 942.926 954.623C932.313 961.183 919.06 961.779 907.9 956.199L649.333 826.916L374.667 964.249L83.9003 818.866C71.7041 812.768 64 800.302 64 786.667V100C64 88.9144 69.1074 78.4469 77.8452 71.6246C86.5829 64.8024 97.9766 62.3862 108.731 65.0749L374.667 131.559L649.333 62.8921ZM136 146.108V764.417L374.667 883.751L649.333 746.417L888 865.751V196.775L649.333 137.108L374.667 205.775L136 146.108Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M346.835 660.304C346.835 617.118 381.844 582.11 425.029 582.11C468.215 582.11 503.223 617.118 503.223 660.304C503.223 703.489 468.215 738.498 425.029 738.498C381.844 738.498 346.835 703.489 346.835 660.304Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M208 477.585C208 448.501 231.577 424.923 260.661 424.923C289.746 424.923 313.323 448.501 313.323 477.585C313.323 506.669 289.746 530.246 260.661 530.246C231.577 530.246 208 506.669 208 477.585Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M619.67 311.654C661.779 327.571 694.19 363.236 705.605 407.351C724.461 395.869 737.052 375.119 737.052 351.428C737.052 315.293 707.759 286 671.625 286C650.452 286 631.628 296.057 619.67 311.654Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M750.572 465.66C750.572 447.593 765.219 432.946 783.286 432.946C801.353 432.946 816 447.593 816 465.66C816 483.728 801.353 498.374 783.286 498.374C765.219 498.374 750.572 483.728 750.572 465.66Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M452.956 442.477C452.956 377.699 505.469 325.186 570.247 325.186C635.025 325.186 687.538 377.699 687.538 442.477C687.538 507.255 635.025 559.768 570.247 559.768C505.469 559.768 452.956 507.255 452.956 442.477Z",
      fill: "#0A3A83"
    }
  )
] });
export {
  VisualisationSpatialScatterplotIcon
};
